export default __webpack_public_path__ + "static/Janis-Joplin-28e7d0205d70e43f26db6e9a8234a14c.jpg";